export default __webpack_public_path__ + "static/bg-2-f3c2462df0642d3b4609418d92118587.png";